
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js';

import config from '../config/config.js'
import VueConfig from 'vue-config';
Vue.use(VueConfig, config);

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import moment from 'moment'
Vue.prototype.moment = moment

import auth from '../plugins/auth.js'
Vue.use(auth)

import URL from '../plugins/url.js'
Vue.use(URL)

import geoimg from '../plugins/geoimg.js'
Vue.use(geoimg)

import geo from '../plugins/geo.js'
Vue.use(geo)

import finder from '../plugins/finder.js'
Vue.use(finder)

import number from '../plugins/number.js';
Vue.use(number);

import datetime from '../plugins/datetime.js';
Vue.use(datetime);

import report from '../plugins/report.js';
Vue.use(report);

import zone from '../plugins/zone.js';
Vue.use(zone);

import asset from '../plugins/asset.js';
Vue.use(asset);

import worker from '../plugins/worker.js';
Vue.use(worker);

import VueNoty from 'vuejs-noty'
Vue.use(VueNoty, {
	// progressBar: false,
	closeWith: ['button'],
	theme: 'metroui',
})

if (window.location.href.match('://localhost')) {
	Vue.config.performance = true;
}

import axios from '../config/http/index.js'

String.prototype.trunc = function (n) {
	return this.substr(0, n - 1) + (this.length > n ? '...' : '');
};


const app = new Vue({
	render: h => h(App),
	router,
	store,
	axios
}).$mount('#app')
